import { render, staticRenderFns } from "./AudioPlayerLead.vue?vue&type=template&id=34cd9342&scoped=true"
import script from "./AudioPlayerLead.vue?vue&type=script&lang=ts"
export * from "./AudioPlayerLead.vue?vue&type=script&lang=ts"
import style0 from "./AudioPlayerLead.vue?vue&type=style&index=0&id=34cd9342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cd9342",
  null
  
)

export default component.exports